


































import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';
import * as Common from '@/agiles/common';
import {Editor,CustomDirectEditProvider} from '@/agiles/common/validator';

@Component
export default class MessageList extends Vue {
  @Prop({ default: null }) public item: Common.StateObject;
  @Prop({ default: null }) public editor: Components.Editor;
  @Prop({ default: true }) public enabled: boolean;

  // ***** 新規メッセージダイアログ *****

  showDialog: boolean = false;
  isNote: boolean = false;
  destination: string = '';
  body: string = '';



  //新規メッセージダイアログを表示する
  onShowDialog() {
    //フィールドの初期化
    this.isNote = false;
    this.destination = '';
    this.body = '';

    //ダイアログの表示
    this.showDialog = true;
  }
  // 新規メッセージを保存する
  onAddMessage(event: any) {
    //バリデーション
    const destination = (this.$refs.destination as any) as Components.IControl;
    const body = (this.$refs.body as any) as Components.IControl;

    var validated1 = this.isNote || destination.validator.validate();
    var validated2 = body.validator.validate();

    if ((validated1 && validated2) == false) {
      event.cancel();
      return;
    }

    this.showDialog = false;
    const msg = new Common.WorkflowMessage();
    msg.userId = this.$api.auth.userId;
    msg.isNote = this.isNote;
    msg.destination = this.destination;
    msg.description = this.body;
    msg.timeStamp = null; //新規メッセージをマークする
    // this.items.unshift(msg); //先頭に追加する
    this.item.workflowMessage = msg;
    this.editor.owner.onDirectCommit(); //親オブジェクト経由更新する(メールを送信する必要がある)
    // this.onDirectCommit(); //クローンは取らずに直接更新する
  }
  // ***** 新規メッセージダイアログ(終了) *****
  public workflowHistories : Common.WorkflowHistory[] = new Array();
  public items: Common.WorkflowMessage[] = new Array(0);

  public get owner() {
    //editor.ownerを偽装してコントロールに自分自身を渡す
    return this;
  }
  addControl(control: Components.IControl) {
    //テキストボックスのproviderにセットしたい
    control.isEdit = false;
  }
  removeControl(control: Components.IControl){
    //特に何もしない
  }
  created() {
    this.onItemChanged();
  }

  @Watch('item')
  onItemChanged() {

    //DBロードする
    if (this.item) {
      var query = new Common.WorkflowInfoQuery(this.item.auditName,this.item.auditNo);
      this.$api.execute(query).then(res =>{
        var result = res as Common.WorkflowInfo;
        this.workflowHistories = result.workflowHistories;
        this.items = result.workflowMessages;
      });
    } else {
        this.workflowHistories = new Array();
        this.items = new Array();      
    }

    

    // if (this.item.workflowMessage) {
    //   const result = new Array<Common.WorkflowMessage>();
    //   (JSON.parse(this.item.workflowMessage) as Array<any>).forEach(source => {
    //     const target = new Common.WorkflowMessage();
    //     Object.assign(target, source);
    //     result.push(target);
    //   });
    //   result.sort((a, b) => (a.timeStamp > b.timeStamp ? -1 : 1));
    //   this.items = result;
    // } else {
    //   this.items = new Array<Common.WorkflowMessage>();
    // }
  }

  public getEditor(index :number)
  {
    //全てオーバーライドする
    var editor = new Editor();
    editor.addControl = (control: Components.IControl) => this.addControl(control);
    editor.removeControl =  (control: Components.IControl) => this.removeControl(control);
    editor.owner = new CustomDirectEditProvider();
    editor.owner.onDirectCommit = () => this.onDirectCommit(index);
    editor.owner.onDirectClose = () => this.onDirectClose();
    editor.owner.hasDirectPerm = () => this.hasDirectPerm();
    return editor;
  }
  //IDirectEditProviderの実装
  hasDirectPerm(): boolean {
    //独自の権限判定が必要になる～暫定実装★★★
    //コントロール側ではどの項目がアクティブなのかわからない
    return true;
  }
  onDirectEdit() {
    //ListViewにリダイレクトしてオブジェクトをクローン～クローンは不要    
    //if (this.editor.owner) this.editor.owner.onDirectEdit();
  }
  onDirectCommit(index:number) {
    //編集中のindexを知る必要がある～editorそのものをコントロール別に偽装する必要がある
    //削除してからリロード
    this.$api.update(this.items[index]).then(res => this.onItemChanged());


    // //仮想コレクションからJSONに変換してバインドを更新する
    // const updated = JSON.stringify(this.items);
    // this.item.workflowMessage = updated;
    // // this.$emit('update:value', updated);
    // //オブジェクトを保存する
    // if (this.editor.owner) {
    //   this.$nextTick(() => this.editor.owner.onDirectCommit());
    // }
  }
  onDirectClose() {
    //クローンは不要
    // if (this.editor.owner) this.editor.owner.onDirectClose();
    
    //リロードは必要
    this.onItemChanged();
  }
  onDirectDelete(index: number) {
    //削除してからリロード
    this.$api.remove(this.items[index]).then(res => this.onItemChanged());
    // this.items.splice(index, 1);
    // const updated = JSON.stringify(this.items);
    // this.item.workflowMessage = updated;
    // // this.$emit('update:value', updated);
    // //オブジェクトを保存する
    // if (this.editor.owner) {
    //   this.$nextTick(() => this.editor.owner.onDirectCommit());
    // }
  }
  getHeader(item: Common.WorkflowMessage) {
    if (item.isNote) {
      return 'メモ by ' + this.$api.formatter.formatByList(item.userId, 'user') + ' on ' + this.$api.formatter.formatTimeStamp(item.timeStamp);
    } else {
      const temp = new Array<string>();
      if(item.destination) item.destination.split(',').forEach(obj => temp.push(this.$api.formatter.formatByList(obj, 'user')));
      return 'メッセージ from ' + this.$api.formatter.formatByList(item.userId, 'user') + ' to ' + temp.join(',') + ' on ' + this.$api.formatter.formatTimeStamp(item.timeStamp);
    }
  }
}
